export interface FAQItem {
  id: string;
  number: string;
  question: string;
  answer: string;
}

export const FAQ_DATA: FAQItem[] = [
  {
    id: "faq-1",
    number: "01",
    question: "What types of products do you manufacture?",
    answer:
      "We specialize in more than 20 handcrafted product categories, including Brass, Copper, Stainless Steel, Iron, Aluminum, Wood, Marble, Glass, Resin, Leather, and mixed-material products for home décor, furniture, lighting, accessories, and private label collections.",
  },
  {
    id: "faq-2",
    number: "02",
    question: "Can you manufacture custom-designed products?",
    answer:
      "Absolutely. Whether you have a hand sketch, CAD drawing, 3D model, reference image, or just an idea, our product development team works closely with you to transform your concept into a premium-quality product tailored to your brand.",
  },
  {
    id: "faq-3",
    number: "03",
    question: "Do you provide product development and prototyping?",
    answer:
      "Yes. We offer complete product development services, including design refinement, material selection, prototype creation, sampling, and production optimization before moving into large-scale manufacturing.",
  },
  {
    id: "faq-4",
    number: "04",
    question: "Do you export products internationally?",
    answer:
      "Yes. We serve clients across global markets and manufacture products that comply with international quality standards. Our team manages production, quality inspections, packaging, and export documentation for a smooth delivery process.",
  },
  {
    id: "faq-5",
    number: "05",
    question: "How do you ensure product quality?",
    answer:
      "Quality is maintained through strict material inspections, skilled craftsmanship, multi-stage quality control, precision finishing, and final packaging checks. Every shipment is carefully reviewed before dispatch to ensure it meets client expectations.",
  },
  {
    id: "faq-6",
    number: "06",
    question: "Why choose The Quality Collection Private Limited as your manufacturing partner?",
    answer:
      "We are more than a manufacturer—we are a long-term production partner. Clients choose us for our customization expertise, transparent communication, reliable delivery, premium craftsmanship, and our ability to turn complex ideas into commercially successful products.",
  },
];